import { IIntTermsFieldSchema } from '../../repositories/newbuilding-promos/entities/json_query/IntTermsFieldSchema';
import { EJsonQueryType, IJsonQueryTerms } from '../../types/jsonQuery/term';

export function mapJsonQueryNumberTerms(term?: IIntTermsFieldSchema | null): IJsonQueryTerms<number> | null {
  if (!term) {
    return null;
  }

  return {
    type: EJsonQueryType.Terms,
    value: term.value,
  };
}
